<template>
  <Dialog :visible="state.visible" modal header="Review existing employee profiles" class="w-full max-w-2xl" :base-z-index="1500" @update:visible="close">
    <EmployeeDuplicateReview v-model="state.decision" :matches="state.matches" :can-override="canOverride" id-prefix="employee-edit-duplicate" />
    <Message v-if="state.error" severity="error" :closable="false">{{ state.error }}</Message>
    <template #footer>
      <Button label="Cancel" severity="secondary" text @click="close" />
      <Button v-if="!blocked" label="Save with recorded decision" @click="apply" />
    </template>
  </Dialog>
</template>
<script setup>
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Message from 'primevue/message';
import EmployeeDuplicateReview from './EmployeeDuplicateReview.vue';
import { employeeDuplicateDialog as state, resolveEmployeeDuplicateDialog } from '@/composables/useEmployeeDuplicateDialog';
import { duplicateDecision, duplicateDisposition } from '@/utils/employeeDuplicates';
import { useAuth } from '@/composables/useAuth';
const { isSuperAdmin, hasPermission } = useAuth();
const route = useRoute();
const canOverride = computed(() => isSuperAdmin.value || hasPermission('employees.duplicate_override'));
const blocked = computed(() => state.matches.some(match => duplicateDisposition(match) === 'block'));
const close = () => resolveEmployeeDuplicateDialog();
function apply() {
  const result = duplicateDecision(state.matches, state.decision, canOverride.value);
  if (result.error) { state.error = result.error; return; }
  resolveEmployeeDuplicateDialog(result.payload);
}
watch(() => route.fullPath, close);
</script>
